import React from 'react';
import { observer, inject } from 'mobx-react';
import * as DataList from 'components/DataList';
import PaymentTransactions, {
  TRANSACTION_COLUMNS, TRANSACTION_CARDS, TRANSACTION_MIN_TABLE_WIDTH,
} from 'components/Tables/PaymentTransactions';

// Billing > Billing history: the payments made for your subscription.
@inject('billingStore') @observer
class BillingHistory extends React.Component {

  componentDidMount() {
    // Not loaded: GET /billing/payment_transactions was switched off before
    // the redesign, so the list shows what's already in the store.
    // this.props.billingStore.loadTransactions()
  }

  render() {
    const { billingStore } = this.props;
    const { isLoading, isError, objects } = billingStore.payment_transactions;

    if (isLoading) {
      return (
        <DataList.Loading
          columns={TRANSACTION_COLUMNS}
          cards={TRANSACTION_CARDS}
          minTableWidth={TRANSACTION_MIN_TABLE_WIDTH}
          noun="payments"
          rows={4}
        />
      );
    }
    if (isError) {
      return <DataList.LoadError noFilters noun="payments" onRetry={() => billingStore.loadTransactions()} />;
    }
    if (!objects || objects.length === 0) {
      return (
        <DataList.Notice
          icon="history"
          title="No payments yet"
          message="Your billing history shows here once invoices are generated."
        />
      );
    }
    return <PaymentTransactions objects={objects} />;
  }
}

export default BillingHistory;
